import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, CommonTypes } from 'st-common/App/CommonTypes';
import StartQuestionnaireAnswerCommand from '../../Models/Questionnaires/Commands/StartQuestionnaireAnswerCommand';
import UpdateQuestionnaireAnswerCommand from '../../Models/Questionnaires/Commands/UpdateQuestionnaireAnswerCommand';

export interface IAnswerQuestionnaireCommandApiClient {

    /** 
     * Will create a questionnaire question answered with the questions provided in the command.
     * @param command The start questionnaire answer command
     * @returns A task awaiting the completion of the command
     */
    startQuestionnaireAnswers(command: Model.PartialPlainObject<StartQuestionnaireAnswerCommand>): AxiosPromise<number>;

    /** 
     * Will update a questionnaire answered with the answers provided in the command.
     * @param command The update questionnaire answer command
     * @returns A task awaiting the completion of the command
     */
    updateQuestionnaireAnswers(command: Model.PartialPlainObject<UpdateQuestionnaireAnswerCommand>): AxiosPromise;

    // Client only properties / methods
}

@injectable()
export default class AnswerQuestionnaireCommandApiClient extends Data.ApiClientBase implements IAnswerQuestionnaireCommandApiClient {

    constructor (config = AppService.get(CommonTypes.Config)) {
        super(`${config.AwardsApi.ApiPath}/questionnaire/answers`);
    }

    public startQuestionnaireAnswers(command: Model.PartialPlainObject<StartQuestionnaireAnswerCommand>): AxiosPromise<number> {
        return this.axios.post(`${this.apiPath}/create`, command);
    }

    public updateQuestionnaireAnswers(command: Model.PartialPlainObject<UpdateQuestionnaireAnswerCommand>): AxiosPromise {
        return this.axios.post(`${this.apiPath}/update`, command);
    }

    // Client only properties / methods
}